export default __webpack_public_path__ + "static/media/icon.cdecf920.png";